import { ComponentPropsWithoutRef, ComponentRef, FC, ReactNode, Ref } from 'react';
import classNames from 'classnames';
import { Dialog as RadixDialog } from 'radix-ui';

import { CloseIcon } from '../../../icons';

import styles from './ModalClose.module.css';

export type ModalCloseProps = {
  children?: ReactNode;
  className?: string;
  ref?: Ref<ComponentRef<typeof RadixDialog.Close>>;
} & Omit<ComponentPropsWithoutRef<typeof RadixDialog.Close>, 'className'>;

const DEFAULT_CLOSE_LABEL = 'Закрыть';

/** Кнопка закрытия модалки. По умолчанию — иконка крестика, заменяется через children. */
const ModalClose: FC<ModalCloseProps> = ({ children, className, ref, ...rest }) => (
  <RadixDialog.Close
    ref={ref}
    aria-label={children === undefined ? DEFAULT_CLOSE_LABEL : undefined}
    {...rest}
    className={classNames(styles.close, className)}>
    {children ?? <CloseIcon />}
  </RadixDialog.Close>
);

export default ModalClose;
